import React from 'react'

const Manual_admin_usuario_administrativo = () => {
  return (
    <div className="px-4 py-16 mx-auto sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-10">
    <div className="mt-16">
      <h2 className="font-bold xl-text-[40px] lg:text-4xl md:text-4xl text-4xl text-[#002D33] mb-5">
        Admin - Usuario Administrativo
      </h2>
      <p className="text-lg text-gray-700 mb-6">
        Esta guía proporciona un proceso paso a paso para crear cuentas de usuario administrativas, lo que garantiza que los usuarios puedan administrar de manera eficiente el acceso y los permisos del sistema. Describe los requisitos de información esenciales, incluidas las credenciales de usuario, los roles y las configuraciones de cuenta, que son cruciales para mantener la seguridad y la integridad operativa.
      </p>
      <iframe
        src="https://scribehow.com/embed/Admin__Usuario_Administrativo__Qa-_A1dqTLGC4w5gwNX2KA?as=scrollable"
        className="scribe-iframe-general-53"
        width="100%"
        height="8050"
        allowFullScreen
        style={{ border: 0, minHeight: '640px' }}
      ></iframe>
    </div>
  </div>
  )
}

export default Manual_admin_usuario_administrativo